import * as React from 'react';
import { SUGGEST_ITEM_FLEX_GAP_SIZE } from '../constants';
export function useIconMargin(suggestions) {
  // В этот список попадают только элементы иконок из итемов с { type: 'title' }.
  // Только они нужны для расчета отступа.
  const titleItemsIconElements = React.useRef([]);
  const [iconMargin, setIconMargin] = React.useState(0);
  React.useEffect(() => {
    titleItemsIconElements.current = [...Array(suggestions.length)].map((_el, i) => titleItemsIconElements.current[i]);
    setIconMargin(Math.max(0, ...titleItemsIconElements.current.map(el => {
      var _el$clientWidth;
      return (_el$clientWidth = el === null || el === void 0 ? void 0 : el.clientWidth) !== null && _el$clientWidth !== void 0 ? _el$clientWidth : 0;
    })));
  }, [suggestions]);
  const setTitleItemRefByIndex = React.useCallback(listIndex => iconElement => {
    if (suggestions[listIndex].type === 'title') {
      titleItemsIconElements.current[listIndex] = iconElement;
    }
  }, [suggestions]);
  const getIconMarginForItem = React.useCallback(suggestion => {
    if (suggestion.leftIcon || !iconMargin) {
      return 0;
    }
    return iconMargin + SUGGEST_ITEM_FLEX_GAP_SIZE;
  }, [iconMargin]);
  return {
    getIconMarginForItem,
    setTitleItemRefByIndex
  };
}